import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { LocalContentService } from '../../../services/local-content/local-content.service'
import { ProfileService } from '../../../services/profile/profile.service'
import { VocabularyService } from '../../../services/vocabulary/vocabulary.service'

@Component({
  selector: 'app-set-cache',
  templateUrl: './set-cache.page.html',
  styleUrls: ['./set-cache.page.scss'],
})
export class SetCachePage implements OnInit {
  constructor(private modalController: ModalController,
              private localContentService: LocalContentService,
              private profileService: ProfileService,
              public vS:VocabularyService) { }

  public opts=[];
  public cacheCode="ALL";

  ngOnInit() {
    this.localContentService.getStaticContent().subscribe((data)=>{
      this.opts=Object.keys(data.meta.cachemode).map(key=> ({
        key,
        description: data.meta.cachemode[key]
      }));
    });
    this.profileService.getCacheCode().subscribe((code)=>{
      this.cacheCode=code;
    });
  }

  public set()
  {
    this.profileService.setCacheCode(this.cacheCode);
    this.localContentService.clearCaches();     
    this.modalController.dismiss();
  }

  public cancel()
  {
    this.modalController.dismiss();
  }

}
